namespace $.$$ {
	$mol_style_define( $shm_mentionstat_items, {
		flex: { grow: 1, shrink: 1 },
		minWidth: 0,
		Grid: { flex: { grow: 1, shrink: 1 }, minWidth: 0, width: '100%' },
		Actions: { gap: 0 },
		Controls: {
			alignItems: 'center',
			padding: $mol_gap.block,
		},
		Status: { color: $mol_theme.shade },
	} )
}
